module.exports = __webpack_public_path__ + "img/img3.95dd9aec.png";